import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/reducers'
import { Observable } from 'rxjs'
import { CountableLinkSummary } from 'src/app/models/latest-aggregate-amounts.model'
import { getTiktokFollowers, getLoading } from 'src/app/selectors/latest-aggregate-amounts.selector'
import { Artist } from 'src/app/models/artist.model'
import { getSelectedArtist } from 'src/app/selectors/artist.selector'
import {
  getDataCollectByTiktokFollower,
  getDataCollectLoading,
} from 'src/app/selectors/data-collections.selector'

@Component({
    selector: 'app-aggregated-amounts-tiktok-follower',
    templateUrl: './aggregated-amounts-tiktok-follower.component.html',
    styleUrls: ['./aggregated-amounts-tiktok-follower.component.scss'],
    standalone: false
})
export class AggregatedAmountsTiktokFollowerComponent implements OnInit {
  tiktokFollower$: Observable<CountableLinkSummary>
  selectedArtist$: Observable<Artist>
  loading$: Observable<boolean>

  dataCollections$: Observable<boolean>
  dataCollectLoading$: Observable<boolean>

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.tiktokFollower$ = this.store.select(getTiktokFollowers)
    this.selectedArtist$ = this.store.select(getSelectedArtist)
    this.loading$ = this.store.select(getLoading)

    this.dataCollections$ = this.store.select(getDataCollectByTiktokFollower)
    this.dataCollectLoading$ = this.store.select(getDataCollectLoading)
  }
}
